import { render, staticRenderFns } from "./ProgramQuestionsAdminSuper.vue?vue&type=template&id=aec3d512&scoped=true&lang=pug&"
import script from "./ProgramQuestionsAdminSuper.vue?vue&type=script&lang=js&"
export * from "./ProgramQuestionsAdminSuper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec3d512",
  null
  
)

export default component.exports